export const CarRentalSearchStrip = {
  SearchStrip: {
    background: "#e8eff2",
    smallscreen: {
      background: "#b9ced8",
    },
  },
  itemType: {
    fontWeight: "bold",
    smallscreen: {
      color: "white",
      fontWeight: "normal",
    },
  },
  location: {
    borderRadius: 0,
  },
  date: {
    borderRadius: 0,
  },
};

export const CarRentalFilters = {
  FiltersBar: {
    background: "#e8eff2",
  },
};

export const carRentalStyles = {
  priceTitle: {
    fontWeight: 800,
    fontSize: "x-large",
  },
  priceSubTitle: {
    fontWeight: 600,
    fontSize: "small",
  },
  bookBtn: {
    ButtonDefault: {
      background: "black",
      borderColor: "black",
      "&:hover": {
        color: "black",
        background: "white",
      },
    },
  },
};

export const CarPreBook = {
  extraInfo: {
    fontWeight: 500,
  },
  priceContr: {
    fontWeight: 800,
    fontSize: "x-large",
  },
};

export const carDriverAge = {
  input: {
    borderRadius: 0,
  },
};
